module.exports = __webpack_public_path__ + "2e649a3f6286c1c4b993fb84407aedf5.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Regular.woff
// module id = 700
// module chunks = 0